<template>
  <!-- Infrastructure Solution Section -->
  <section
    class="infrastructure-section text-white d-flex align-items-center technohero"
  >
    <!-- Overlay for darker background -->
    <div
      class="overlay"
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 50, 0.6);
        z-index: 1;
      "
    ></div>

    <div class="container position-relative" style="z-index: 2">
      <div class="row align-items-center">
        <!-- Left Content -->
        <div class="col-lg-6 text-start">
          <h1 class="fw-bold text-uppercase">Infrastructure Solution</h1>
          <p class="lead">Memperkenalkan Teknologi Terbaik Skyreach</p>
          <a
            href="#explore"
            class="btn btn-orange rounded-pill px-5 btn-lg fw-bold px-4"
            >Explore</a
          >
        </div>
      </div>
    </div>
  </section>

  <!-- ABOUT COMPANY (ORANGE BG) -->
  <section class="about-orange py-5">
    <div class="container">
      <p class="lead text-white mb-0">
        Infrastruktur Terbaik kami seperti fasilitas stasiun satelit bumi
        (Teleport), pusat data (data-center) dan pusat pemantauan (network
        operation center) yang berlokasi di Cikarang, Jawa Barat. Seluruh
        fasilitas terbaik ini beroperasi 24 jam dengan dukungan sistem
        kelistrikan yang andal. Seluruh jaringan saling terkoneksi dan
        terproteksi fully-redundant ke interkoneksi kami yang berlokasi di Cyber
        Building, Jakarta.
      </p>
    </div>
  </section>

  <!-- Solutions Section -->
  <!-- Solutions Section -->
  <section class="solutions py-5">
    <div class="container">
      <!-- Item 1 -->
      <div class="row mb-5 align-items-center">
        <!-- Image -->
        <div class="col-lg-5 order-1 order-lg-2 text-center mb-3 mb-lg-0">
          <img
            src="@/assets/images/tech_1.png"
            alt="Industry Solution"
            class="img-fluid rounded-3 shadow"
          />
        </div>
        <!-- Text -->
        <div class="col-lg-7 order-2 order-lg-1">
          <h6 class="fw-bold text-primary mb-3">
            <span class="text-warning me-2">●</span> INDUSTRY SOLUTION
          </h6>
          <p>
            <strong>Skyreach</strong> memahami bahwa tantangan bisnis di setiap
            industri akan menantang dan beragam, solusi terintegrasi yang
            menyesuaikan kebutuhan bisnis di sektor apapun.
          </p>
          <p>
            Melalui infrastruktur Teknologi Informasi dan Komunikasi yang
            lengkap, serta dukungan teknisi Andal,
            <strong>Skyreach</strong> siap membantu Anda mencapai transformasi
            digital untuk operasional bisnis yang lebih efisien.
          </p>
        </div>
      </div>

      <!-- Item 2 -->
      <div class="row mb-5 align-items-center">
        <!-- Image -->
        <div class="col-lg-5 order-1 order-lg-2 text-center mb-3 mb-lg-0">
          <img
            src="@/assets/images/tech_2.png"
            alt="Customer Experience"
            class="img-fluid rounded-3 shadow"
          />
        </div>
        <!-- Text -->
        <div class="col-lg-7 order-2 order-lg-1">
          <h6 class="fw-bold text-primary mb-3">
            <span class="text-warning me-2">●</span> CUSTOMER EXPERIENCE &
            MONITORING CENTER
          </h6>
          <p>
            Pusat Pengaturan Operasional Jaringan (NOC)
            <strong>Skyreach</strong> senantiasa bergerak dengan dukungan tim
            teknisi yang bekerja 24 jam setiap harinya. NOC
            <strong>Skyreach</strong> selalu menggunakan media komunikasi yang
            memudahkan Pelanggan setiap kali untuk menikmati pelayanan.
          </p>
          <p>
            Berbagai media komunikasi dapat digunakan seperti telepon,
            <em>handphone</em>, <em>messenger</em> maupun <em>e-mail</em> dengan
            tujuan agar Pelanggan dapat memperoleh respon dan eskalasi yang
            cepat.
          </p>
        </div>
      </div>

      <!-- Item 3 -->
      <div class="row align-items-center">
        <!-- Image -->
        <div class="col-lg-5 order-1 order-lg-2 text-center mb-3 mb-lg-0">
          <img
            src="@/assets/images/tech_3.png"
            alt="Service Solution"
            class="img-fluid rounded-3 shadow"
          />
        </div>
        <!-- Text -->
        <div class="col-lg-7 order-2 order-lg-1">
          <h6 class="fw-bold text-primary mb-3">
            <span class="text-warning me-2">●</span> SERVICE SOLUTION
          </h6>
          <p>
            <strong>Skyreach</strong> memahami bahwa kebutuhan operasional tidak
            cukup hanya menggunakan perangkat <em>hardware</em>, namun juga
            didukung oleh <em>software</em> yang up to date.
          </p>
          <p>
            Melalui <em>software</em> tersebut sangat membantu
            <strong>monitor</strong> dan otomasi bisnis perusahaan anda menjadi
            lebih mudah.
          </p>
          <p>
            Segala kemudahan ini menjadikan <em>software</em> pendukung seperti
            <strong>Satlink Navigator Plus</strong> dan
            <strong>Solosign</strong> menjadi satu aplikasi yang selalu dapat
            dinikmati oleh pelanggan kami.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
